"use client";

import * as React from "react";
import {
  BadgePercent,
  GalleryVerticalEnd,
  LayoutDashboard,
  Megaphone,
  Settings,
  ShoppingBag,
  Users,
  
} from "lucide-react";

import { NavMain } from "@/components/nav-main";
import { NavUser } from "@/components/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  useSidebar,
} from "@/components/ui/sidebar";

// This is sample data.
const data = {
  navMain: [
    {
      title: "Dashboard",
      url: "/dashboard",
      icon: LayoutDashboard,
    },
    {
      title: "Ecommerce",
      url: "/products",
      icon: ShoppingBag,
      items: [
        {
          title: "Products",
          url: "/products",
        },
        {
          title: "Categories",
          url: "/categories",
        },
        {
          title: "Attributes",
          url: "/attributes",
        },
        {
          title: "Attribute Families",
          url: "/attribute-families",
        },
      ],
    },
    {
      title: "Customers",
      url: "/customers",
      icon: Users,
      items: [
        {
          title: "Customers",
          url: "/customers",
        },
        {
          title: "Customer Groups",
          url: "/customer-groups",
        },
      ],
    },
    {
      title: "Sales",
      url: "/orders",
      icon: BadgePercent,
      items: [  
        {
          title: "Orders",
          url: "/orders",
        },
        {
          title: "Invoices",
          url: "/invoices",
        }
      ],
    },
    {
      title: "Promotions",
      url: "/promotions",
      icon: Megaphone,
    },
    {
      title: "Media",
      url: "/media",
      icon: GalleryVerticalEnd,
    },
    {
      title: "Settings",
      url: "/settings",
      icon: Settings,
      items: [
        {
          title: "General",
          url: "/settings/general",
        },
        {
          title: "Shipping",
          url: "/settings/shipping",
        },
        {
          title: "Payment",
          url: "/settings/payment",
        },
        {
          title: "Tax Categories",
          url: "/settings/tax-categories",
        },
        {
          title: "Tax Rates",
          url: "/settings/tax-rates",
        },
        {
          title: "Roles",
          url: "/settings/roles",
        }
      ]
    }
  ],
};

export function AppSidebar({ user, ...props }: {user?:any} & React.ComponentProps<typeof Sidebar>) {
  const { state } = useSidebar();
  return (
   
    <Sidebar variant="floating" {...props} >
       <SidebarHeader className="mb-8">
      <div className="px-2 py-2">
        {state === "collapsed" ? (
          <span className="text-xl font-semibold text-[#18181a] dark:text-[#e7e7e4]">A</span>
        ) : (
          <span className="text-xl font-semibold text-[#18181a] dark:text-[#e7e7e4]">Admin</span>
        )}
      </div>
    </SidebarHeader>
      <SidebarContent>
        <NavMain items={data.navMain} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser user={user} />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>

    
  );
}
